<template>
    <v-container fluid>
        <div style="width: 100%">
            <v-row class="d-flex justify-center py-1" no-gutters>
                <v-col :cols="$vuetify.display.mobile ? '12' : '12'" class="pa-2">
                    <v-row no-gutters>
                        <v-col :cols="$vuetify.display.mobile ? '12' : '1'">
                            <div class="d-flex align-center justify-start ml-5">
                                <v-btn-back @click="$router.go(-1)"> </v-btn-back>
                            </div>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? '12' : '8'">
                            <h1 class="ml-2 d-flex justify-start align-center">
                                Bilan mensuel des Z de caisses
                            </h1>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="d-flex justify-center py-1">
                <v-col cols="3">
                    <v-select
                        v-model="accountingPeriod"
                        :items="accountingPeriods"
                        label="Exercice comptable"
                        :item-title="computeAccountingPeriodText"
                        item-value="id"
                        return-object
                        rounded
                        :readonly="!accountingPeriods || accountingPeriods.length === 1"
                        v-show="true"
                        @update:model-value="accountingPeriodChange()"
                    />
                </v-col>
            </v-row>
            <v-row v-for="month in months" :key="month.name" class="d-flex justify-center py-1">
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '8'"
                    class="pa-0 d-flex justify-center"
                    style="cursor: pointer"
                >
                    <oss-card :icon="'trending_up'" :icon-color="'secondary'">
                        <template #left>
                            <v-row no-gutters @click="openZtillCalendar(month)">
                                <v-col cols="6">
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <span
                                                class="ml-2"
                                                style="
                                                    font-weight: bold;
                                                    font-size: 14pt;
                                                    text-transform: capitalize;
                                                "
                                            >
                                                {{ month.name }}
                                            </span>
                                            <span
                                                v-if="
                                                    month.diffAmount >= 0 &&
                                                    month.diffAmount != null
                                                "
                                                class="ml-2 mt-1"
                                                style="font-size: 10pt; color: #5fc9b8"
                                            >
                                                (+{{
                                                    newCommonFormatCurrency(
                                                        month.diffAmount,
                                                        undefined,
                                                    )
                                                }})
                                            </span>
                                            <span
                                                v-else-if="
                                                    month.diffAmount < 0 && month.diffAmount != null
                                                "
                                                class="ml-2 mt-1"
                                                style="font-size: 10pt; color: #f76631"
                                            >
                                                ({{
                                                    newCommonFormatCurrency(
                                                        month.diffAmount,
                                                        undefined,
                                                    )
                                                }})
                                            </span>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        v-if="month.warning && month.auditCheckStatus !== 'IGNORE'"
                                        no-gutters
                                    >
                                        <v-col cols="12">
                                            <span class="ml-2" style="font-size: 10pt">
                                                <v-icon color="warning">$warning</v-icon>
                                                Z de caisse(s) manquant(s)
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="6">
                                    <v-row class="mr-5 d-flex align-center justify-end" no-gutters>
                                        <v-col cols="12" class="d-flex align-center justify-end">
                                            <span style="font-size: 11pt">
                                                HT :
                                                {{
                                                    newCommonFormatCurrency(
                                                        month.netAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mr-5 d-flex align-center justify-end" no-gutters>
                                        <v-col cols="12" class="d-flex align-center justify-end">
                                            <span style="font-size: 11pt">
                                                TVA :
                                                {{
                                                    newCommonFormatCurrency(
                                                        month.vatAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </template>
                        <template #right>
                            <v-row no-gutters>
                                <v-col style="d-flex align-center">
                                    <v-row
                                        v-if="month.grossAmount !== 0"
                                        class="d-flex justify-center"
                                        no-gutters
                                    >
                                        <v-col cols="12">
                                            <span
                                                style="
                                                    font-weight: bold;
                                                    font-size: 12pt;
                                                    color: #5fc9b8;
                                                "
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        month.grossAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                    <v-row v-else class="d-flex justify-center" no-gutters>
                                        <v-col cols="12">
                                            <span
                                                style="
                                                    font-weight: bold;
                                                    font-size: 12pt;
                                                    color: #f76631;
                                                "
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        month.grossAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex justify-center" no-gutters>
                                        <v-col cols="12">
                                            <v-btn
                                                :hide-details="true"
                                                :outlined="true"
                                                rounded
                                                class="elevation-0"
                                                @click="openZtillCalendar(month)"
                                                >Détails
                                            </v-btn>
                                            <v-btn
                                                :hide-details="true"
                                                :outlined="true"
                                                rounded
                                                @click.stop="ignoreCheck(month)"
                                                v-if="month.auditCheckStatus !== 'IGNORE'"
                                                class="elevation-0 mt-1"
                                                size="small"
                                            >
                                                Ignorer
                                            </v-btn>
                                            <v-btn
                                                :hide-details="true"
                                                :outlined="true"
                                                rounded
                                                @click.stop="ignoreCheck(month)"
                                                v-else
                                                class="elevation-0 mt-1"
                                                size="small"
                                            >
                                                Rétablir
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </template>
                    </oss-card>
                </v-col>
            </v-row>
        </div>
        <CheckBilanZTillWizard
            v-model:active="openCalendar"
            v-if="openCalendar"
            v-bind:companyId="companyId"
            v-bind:inGlobalStep="'ztillCalendar'"
            v-bind:dayCalendarStart="dayCalendarStart"
            v-bind:dayCalendarEnd="dayCalendarEnd"
            v-bind:auditCheckKey="auditCheckKey"
            @created="onZTillCalendarOpen"
        />
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import moment from "moment-timezone";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { Apollo } from "@/decorators";

import ZTILLS_CHECK from "../../graphql/audit/AuditItems.gql";
import UPSERT_AUDITCHECKRESULT_MUTATION from "../../graphql/audit/UpsertAuditCheckResultMutation.gql";
import DELETE_AUDITCHECKRESULT_MUTATION from "../../graphql/audit/DeleteAuditCheckResult.gql";
import GET_AUDITCHECKRESULT from "../../graphql/audit/GetAuditCheckResult.gql";
import { AccountingPeriod } from "../../../../types";

import CheckBilanZTillWizard from "./CheckBilanZTillWizard.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        CheckBilanZTillWizard,
    },
})
export class CheckBilanZTill extends Vue {
    openCalendar: boolean = false;
    dayCalendarStart: string = "";
    dayCalendarEnd: string = "";

    // withAccountingPeriod: boolean = false;
    allCompanies: boolean = false;
    accountingPeriod: any = null;
    // accountingPeriodSelected: any = null;
    months: Array<any> = [];

    openZtillCalendar(month) {
        this.dayCalendarStart = moment(month.date).startOf("month").format("YYYY-MM-DD");
        this.dayCalendarEnd = moment(month.date).endOf("month").format("YYYY-MM-DD");
        this.openCalendar = true;
    }

    getDateFormated(zTill) {
        const date = zTill.date;
        if (date) {
            return moment(date).format("MM/YYYY");
        }
        return "";
    }

    // Get the list of months of actual year if none accounting period is selected
    async lastsmonths() {
        const listMonths = [];
        let diff = 0;
        const month = moment();
        const actualMonth = moment().month();
        for (let i = 0; i < actualMonth + 1; i++) {
            const dateFormat = moment(month).subtract(i, "months").format("YYYY-MM");
            const grossAmountMonth = this.getMonthGrossAmount(dateFormat);

            // Check if zTill are missing
            const warningMonth = this.checkMonthWarning(dateFormat, this.items);

            // get next month grossAmount for diff
            const nextDateFormat = moment(month)
                .subtract(i + 1, "months")
                .format("YYYY-MM");
            const nextGrossAmountMonth = this.getMonthGrossAmount(nextDateFormat);

            // eslint-disable-next-line no-await-in-loop
            const ignore = await this.monthIgnore(dateFormat);

            // if last month of the period, no diff
            if (i === actualMonth) {
                diff = null;
            } else {
                diff = grossAmountMonth - nextGrossAmountMonth;
            }

            listMonths.push({
                id: i,
                name: moment(month).subtract(i, "months").format("MMMM YYYY"),
                date: dateFormat,
                warning: !ignore ? false : warningMonth,
                grossAmount: grossAmountMonth,
                netAmount: this.getMonthNetAmount(dateFormat),
                vatAmount: this.getMonthVATAmount(dateFormat),
                diffAmount: diff,
                auditCheckStatus: !ignore ? "IGNORE" : "",
            });
        }
        this.months = listMonths;
    }

    // Get the list of months when an accounting period is selected
    accountingPeriodChange() {
        const startAccountingPeriod = moment(this.accountingPeriod.start).format("YYYY-MM-DD");
        const endAccountingPeriod = moment(this.accountingPeriod.end).format("YYYY-MM-DD");

        const dateStart = moment(startAccountingPeriod);
        const dateEnd = moment(endAccountingPeriod);
        const interim = dateStart.clone();

        const actualMonth = moment();
        const listMonths = [];
        let i = 0;

        while (
            (dateEnd > interim || interim.format("M") === dateEnd.format("M")) &&
            moment(interim) <= actualMonth
        ) {
            const dateFormat = interim.format("YYYY-MM");
            const warningMonth = this.checkMonthWarning(dateFormat, this.items);
            listMonths.push({
                id: i,
                name: interim.format("MMMM YYYY"),
                date: dateFormat,
                warning: warningMonth,
                grossAmount: this.getMonthGrossAmount(dateFormat),
                netAmount: this.getMonthNetAmount(dateFormat),
                vatAmount: this.getMonthVATAmount(dateFormat),
            });
            i++;
            interim.add(1, "month");
        }
        this.months = listMonths.slice().reverse();
    }

    checkMonthWarning(month, items) {
        const events = [];

        const actualMonth = moment(month).month();
        const actualYear = moment(month).year();

        const actualDate = new Date(actualYear, actualMonth, 1);
        const listDate = [];
        while (actualDate.getMonth() === actualMonth) {
            listDate.push(
                actualYear + "-" + (actualMonth + 1) + "-" + actualDate.getDate() + " AM",
            );
            listDate.push(
                actualYear + "-" + (actualMonth + 1) + "-" + actualDate.getDate() + " PM",
            );
            actualDate.setDate(actualDate.getDate() + 1);
        }

        // Sorted list of ZTills
        items.sort((a, b) => (moment(a.date) > moment(b.date) ? 1 : -1));

        const result = this.checkPeriod(listDate, items);
        return result;
    }

    // Check if the date inputed is in a ztill period
    checkPeriod(date, items) {
        const dateFirst = date[0].split(" ");
        const dateLast = date[date.length - 1].split(" ");
        let cptDay = 0;
        for (const ztill of items) {
            const ztillDate = ztill.date.substring(0, ztill.date.indexOf("T"));
            if (
                ztillDate >= moment(dateFirst[0]).format("YYYY-MM-DD") &&
                ztillDate <= moment(dateLast[0]).format("YYYY-MM-DD")
            ) {
                if (ztill.period === "AM" || ztill.period === "PM") {
                    cptDay++;
                } else if (ztill.period === "DA") {
                    cptDay += 2;
                } else if (ztill.period === "MO") {
                    // cptDay = date.length
                    return false;
                }
            }
        }
        if (cptDay >= date.length) {
            return false;
        }
        return true;
    }

    // Get total gross amount of the month
    getMonthGrossAmount(date) {
        let grossAmount = 0;
        this.items.forEach((item) => {
            const dateItem = moment(item.date).format("YYYY-MM");
            if (dateItem === date) {
                grossAmount += item.grossAmount;
            }
        });
        return grossAmount;
    }

    // Get total net amount of the month
    getMonthNetAmount(date) {
        let netAmount = 0;
        this.items.forEach((item) => {
            const dateItem = moment(item.date).format("YYYY-MM");
            if (dateItem === date) {
                netAmount += item.netAmount;
            }
        });
        return netAmount;
    }

    // Get total vat amount of the month
    getMonthVATAmount(date) {
        let vatAmount = 0;
        this.items.forEach((item) => {
            const dateItem = moment(item.date).format("YYYY-MM");
            if (dateItem === date) {
                vatAmount += item.vatAmount;
            }
        });
        return vatAmount;
    }

    // Close the calendar wizard
    onZTillCalendarOpen() {
        this.openCalendar = false;
        if (this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        }
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get auditCheckKey() {
        return this.$route.params.auditCheckKey;
    }

    get period() {
        return this.$route.params.period;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    // Ignorer l'erreur sur la note de frais
    //
    // audit check
    //
    async monthIgnore(month) {
        const keyACR = this.auditCheckKey + "_" + month;
        const result = await this.$apollo.query({
            query: GET_AUDITCHECKRESULT,
            variables: {
                key: keyACR,
                company: this.companyId,
            },
        });
        if (
            result &&
            result.data &&
            result.data.auditCheckResults &&
            result.data.auditCheckResults[0]
        ) {
            const status = result.data.auditCheckResults[0].status;
            if (status === "IGNORE") {
                return false;
            }
        }
        return true;
    }

    async ignoreCheck(item) {
        const keyACR = this.auditCheckKey + "_" + item.date;
        if (!item.auditCheckStatus || item.auditCheckStatus !== "IGNORE") {
            if (this.auditCheckKey !== undefined) {
                item.auditCheckStatus = "IGNORE";
                const result = await this.$apollo.mutate({
                    mutation: UPSERT_AUDITCHECKRESULT_MUTATION,
                    variables: {
                        key: keyACR,
                        auditCheckKey: this.auditCheckKey,
                        status: "IGNORE",
                        company: this.companyId,
                    },
                });
            }
        } else {
            const result = await this.$apollo.mutate({
                mutation: DELETE_AUDITCHECKRESULT_MUTATION,
                variables: {
                    key: keyACR,
                },
            });
            delete item.auditCheckStatus;
        }
    }

    @Apollo({
        query: ZTILLS_CHECK,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.auditCheckKey,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.items = data.auditItems.items;
                    if (this.period !== null) {
                        this.accountingPeriod = this.period;
                        this.accountingPeriodChange();
                    } else {
                        this.lastsmonths();
                    }
                }
            }
        },
    })
    items: Array<any> = [];

    @Apollo({
        query: gql`
            query ($companyId: ID!) {
                accountingPeriods(where: { company: { id: $companyId } }, orderBy: start_ASC) {
                    id
                    start
                    end
                }
            }
        `,
        skip() {
            return !this.companyId;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data && data.accountingPeriods) {
                if (data.accountingPeriods.length) {
                    this.accountingPeriods = data.accountingPeriods;

                    if (this.accountingPeriods && this.accountingPeriods.length) {
                        // this.accountingPeriod = this.accountingPeriods[this.accountingPeriods.length - 1];
                        const date = moment();
                        for (const ap of this.accountingPeriods) {
                            // eslint-disable-next-line no-shadow
                            const start = moment(ap.start);
                            const end = moment(ap.end);
                            if (date.isSameOrAfter(start) && date.isSameOrBefore(end)) {
                                this.accountingPeriod = ap;
                                break;
                            }
                        }
                    }
                } else {
                    this.accountingPeriod = null;
                    this.accountingPeriods = [];
                }
            } else {
                this.accountingPeriod = null;
                this.accountingPeriods = [];
            }
        },
        debounce: 500,
    })
    accountingPeriods: AccountingPeriod[] = [];

    computeAccountingPeriodText(accountingPeriod) {
        let text = moment(accountingPeriod.start).format("DD-MM-YYYY");
        text += " / ";
        text += moment(accountingPeriod.end).format("DD-MM-YYYY");
        return text;
    }
}

export default toNative(CheckBilanZTill);
</script>
